import { render, staticRenderFns } from "./composantEditionFacture.vue?vue&type=template&id=22028496"
import script from "./composantEditionFacture.vue?vue&type=script&lang=js"
export * from "./composantEditionFacture.vue?vue&type=script&lang=js"
import style0 from "./composantEditionFacture.vue?vue&type=style&index=0&id=22028496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports